module.exports = __webpack_public_path__ + "img/multiple-tickets.9edac1ce.svg";